import { useEffect, useState } from 'react';
export function useStateStore(store, selector) {
    const [state, setState] = useState(() => {
        if (!store)
            return undefined;
        return selector(store.getLatestValue());
    });
    useEffect(() => {
        if (!store)
            return;
        const unsubscribe = store.subscribeWithSelector(selector, setState);
        return unsubscribe;
    }, [store, selector]);
    return state;
}
